import PropTypes from "prop-types";
import React from "react";

/**
 * Filigrane « DUPLICATA » apposé sur la CP et les attestations lorsqu'un avenant
 * de duplicata a été initialisé sur le contrat (payé ou non).
 *
 * L'avenant de duplicata (AD) ne crée PAS de nouvelle version de contrat : il ne
 * fait qu'ajouter une ligne de règlement. Le flag {@code contrat.aDuplicata} est
 * donc calculé et estampillé côté écran de détails (présence d'un règlement dont
 * l'avenant.code === "AD") puis lu ici.
 *
 * Le conteneur parent doit être en {@code position: relative/absolute} (c'est déjà
 * le cas des cartes de documents), les filigranes se centrent alors dessus.
 *
 * {@code panels} : nombre de volets détachables du document. Une attestation
 * physique est découpée en plusieurs volets côte à côte (Moto = 4, CEDEAO = 3) :
 * on répète alors un filigrane centré sur CHAQUE volet plutôt qu'un seul à cheval
 * sur l'ensemble. La CP (page A4 unique) reste à 1.
 */
const DuplicataStamp = ({ contrat, fontSize = 72, panels = 1 }) => {
  if (!contrat?.aDuplicata) return null;

  const n = Math.max(1, panels);
  const border = Math.max(2, Math.round(fontSize / 15));
  const padV = Math.round(fontSize / 7);
  const padH = Math.round(fontSize / 1.8);
  const spacing = Math.max(2, Math.round(fontSize / 18));

  return (
    <>
      {Array.from({ length: n }).map((_, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            top: "50%",
            // Centre chaque filigrane au milieu de son volet.
            left: `${((i + 0.5) / n) * 100}%`,
            transform: "translate(-50%, -50%) rotate(-45deg)",
            color: "red",
            fontSize: `${fontSize}px`,
            fontWeight: "bold",
            opacity: 0.45,
            zIndex: 1000,
            pointerEvents: "none",
            border: `${border}px solid red`,
            padding: `${padV}px ${padH}px`,
            textAlign: "center",
            letterSpacing: `${spacing}px`,
            whiteSpace: "nowrap",
          }}
        >
          DUPLICATA
        </div>
      ))}
    </>
  );
};

DuplicataStamp.propTypes = {
  contrat: PropTypes.object,
  fontSize: PropTypes.number,
  panels: PropTypes.number,
};

export default DuplicataStamp;
